import { Component, Input, OnInit } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { UserBoard, UserBoardTypes } from 'src/app/services/models/user-board.model';
import { UserBoardService } from 'src/app/services/user-board.service';

@Component({
  selector: 'bhub-manage-boards',
  templateUrl: './manage-boards.component.html',
  styleUrl: './manage-boards.component.scss',
  standalone: false
})
export class ManageBoardsComponent implements OnInit {
  @Input() boards: UserBoard[] = []; // all available boards
  
  public manageBoardMode = {
    view: 'view',
    selectType: 'selectType',
    create: 'create',
    edit: 'edit'
  };
  
  public mode: string = this.manageBoardMode.view;
  public selectedBoardType: UserBoardTypes = null;
  public editingBoard: UserBoard = null;
  
  // Board type options for display
  boardTypes = UserBoardTypes;

  constructor(
    private userBoardService: UserBoardService
  ) {}

  ngOnInit() {
    // Component initialization if needed
  }

  getBoardTypeLabel(boardType: UserBoardTypes): string {
    // Handle legacy boards that might not have a board type set
    if (!boardType) {
      return 'Tile Board'; // Default for legacy boards
    }
    
    switch(boardType) {
      case UserBoardTypes.TileBoard:
        return 'Tile Board';
      case UserBoardTypes.SpreadsheetBoard:
        return 'Spreadsheet Board';
      default:
        return 'Unknown';
    }
  }

  startCreating(): void {
    // Show board type selector first
    this.mode = this.manageBoardMode.selectType;
  }

  onBoardTypeSelected(boardType: UserBoardTypes): void {
    this.selectedBoardType = boardType;
    this.editingBoard = null; // Will be created by the specific board editor
    this.mode = this.manageBoardMode.create;
  }

  onBoardTypeSelectionCancelled(): void {
    this.mode = this.manageBoardMode.view;
    this.selectedBoardType = null;
  }

  editBoard(board: UserBoard): void {
    // Handle legacy boards that might not have a board type set
    if (!board.boardType) {
      board.boardType = UserBoardTypes.TileBoard;
    }
    
    this.editingBoard = cloneDeep(board);
    this.selectedBoardType = board.boardType;
    this.mode = this.manageBoardMode.edit;
  }

  deleteBoard(board: UserBoard): void {
    if (confirm(`Are you sure you want to delete "${board.userBoardName}"?`)) {
      this.userBoardService.deleteUserBoard(board).subscribe((response) => {
        const index = this.boards.indexOf(board);
        if (index > -1) {
          this.boards.splice(index, 1);
        }
      });
    }
  }

  onSaveBoard(board: UserBoard): void {
    if (this.mode === this.manageBoardMode.create) {
      this.userBoardService.createUserBoard(board).subscribe((response) => {
        board.userBoardId = response.userBoardId;
        this.boards.push(board);
        this.resetToViewMode();
      });
    } else if (this.mode === this.manageBoardMode.edit) {
      this.userBoardService.updateUserBoard(board).subscribe((response) => {
        // Update the board in the list
        const index = this.boards.findIndex(b => b.userBoardId === board.userBoardId);
        if (index !== -1) {
          this.boards[index] = board;
        }
        this.resetToViewMode();
      });
    }
  }

  onCancelEdit(): void {
    this.resetToViewMode();
  }

  private resetToViewMode(): void {
    this.mode = this.manageBoardMode.view;
    this.editingBoard = null;
    this.selectedBoardType = null;
  }
}